import React, { useState } from 'react';
import axios from 'axios';
import logo_white from '../assets/images/logo-dark.svg';
import app from '../assets/images/app.png';
import playstore from '../assets/images/playstore.png';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'react-feather';
import { FaLinkedin, FaRegEnvelope } from 'react-icons/fa';
import { BsPencil } from 'react-icons/bs';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineInstagram, AiOutlineShoppingCart, AiOutlineTwitter } from 'react-icons/ai';
import { FiDribbble } from 'react-icons/fi';
import { BiLogoBehance } from 'react-icons/bi';
import { LiaFacebookF } from 'react-icons/lia';
import { toast,ToastContainer  } from 'react-toastify';
import {Lock, ShieldCheck} from "lucide-react"
import 'react-toastify/dist/ReactToastify.css';


export default function Footer() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false); // Добавлено состояние для успеха

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post('https://nifty-art.com/api/subscribe', { email }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                toast.success('Thank you for subscribing!');
                setEmail('');
                setSuccess(true); // Устанавливаем состояние успеха

                // Возвращаем текст кнопки к "Subscribe" через 3 секунды
                setTimeout(() => {
                    setSuccess(false);
                }, 3000);
            }
        } catch (error) {
            if (error.response && error.response.data.errors) {
                error.response.data.errors.forEach((err) => toast.error(err.msg));
            } else {
                toast.error('An error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className="footer bg-dark-footer relative text-gray-200 dark:text-gray-200 mt-24">
            <div className="container">
                <div className="grid grid-cols-1">
                    <div className="relative py-16">
                        <div className="relative w-full">
                            <div className="relative -top-40 bg-white dark:bg-slate-900 lg:px-8 px-6 py-10 rounded-xl shadow dark:shadow-gray-800 overflow-hidden">
                                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
                                    <div className="md:text-start text-center z-1">
                                        <h3 className="text-[26px] font-semibold text-slate-900 dark:text-white">Subscribe to Newsletter!</h3>
                                        <p className="text-slate-400 max-w-xl mx-auto">Subscribe to get latest updates and information.</p>
                                    </div>

                                    <div className="subcribe-form z-1">
                                        <form className="relative max-w-lg md:ms-auto" onSubmit={handleSubscribe}>
                                            <input
                                                type="email"
                                                id="subscribe"
                                                name="email"
                                                className="pt-4 pe-40 pb-4 ps-6 w-full h-[50px] outline-none text-slate-900 dark:text-white rounded-full bg-white dark:bg-slate-900 shadow dark:shadow-gray-800"
                                                placeholder="Enter your email :"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                         />
                                            <button
                                                type="submit"
                                                className={`btn absolute top-[2px] end-[3px] h-[46px] bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full ${
                                                    loading || success ? 'opacity-50 cursor-not-allowed' : ''
                                                }`}
                                                disabled={loading || success}
                                            >
                                                {loading ? 'Subscribing...' : success ? 'Success' : 'Subscribe'}
                                            </button>
                                        </form>
                                    </div>
                                </div>

                                <div className="absolute -top-5 -start-5">
                                    <FaRegEnvelope className="lg:text-[150px] text-7xl text-slate-900/5 dark:text-white/5 -rotate-45"/>
                                </div>

                                <div className="absolute -bottom-5 -end-5">
                                   <BsPencil className="lg:text-[150px] text-7xl text-slate-900/5 dark:text-white/5"/>
                                </div>
                            </div>

                            <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px] -mt-24">
                                <div className="lg:col-span-4 md:col-span-12">
                                    <Link to="#" className="text-[22px] focus:outline-none">
                                        <img src={logo_white} alt="" />
                                    </Link>
                                    <p className="mt-6 text-gray-300">We are a leading store dedicated to connect the top artists with NFT art collectors!</p>

                                </div>

                                <div className="lg:col-span-2 md:col-span-4">
                                    <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">NIFTY</h5>
                                    <ul className="list-none footer-list mt-6">
                                        <li><Link to="/explore-one" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Explore Item</Link></li>
                                        <li className="mt-[10px]"><Link to="/wallet" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Wallet</Link></li>
                                        <li className="mt-[10px]"><Link to="/creators" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Creators</Link></li>
                                    </ul>
                                </div>

                                <div className="lg:col-span-3 md:col-span-4">
                                    <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">Usefull Links</h5>
                                    <ul className="list-none footer-list mt-6">
                                        <li className="mt-[10px]"><Link to="/terms" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Terms & Conditions</Link></li>
                                        <li className="mt-[10px]"><Link to="/privacy" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Cookie & Privacy policy</Link></li>
                                        <li className="mt-[10px]"><Link to="/contact" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Contact Us</Link></li>
                                        <li className="mt-[10px]"><Link to="/cookiepolicy" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Cookie Declaration</Link></li>
                                    </ul>
                                </div>

                                <div className="lg:col-span-3 md:col-span-4">
                                    <div className="mt-0">
                                      <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">
                                        Contact Details
                                      </h5>
                                    
                                      <div className="mt-3 space-y-3">
                                        {/* Email */}
                                        <div className="flex items-center">
                                          <Mail className="size-5 text-violet-600 me-3" />
                                          <a
                                            href="mailto:info@nifty-art.com"
                                            className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                                          >
                                            info@nifty-art.com
                                          </a>
                                        </div>
                                    
                                        {/* Phone */}
                                        <div className="flex items-center">
                                          <Phone className="size-5 text-violet-600 me-3" />
                                          <a
                                            href="tel:+447893926971"
                                            className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                                          >
                                            +44 7893 926971
                                          </a>
                                        </div>
                                      </div>


                                
                                    {/* Данные компании */}
                                    <div className="mt-6">
                                      <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">Company Details</h5>
                                      <p className="text-[16px] text-gray-300">JADEFIRST LIMITED</p>
                                      <p className="text-[16px] text-gray-300">
                                        No. 15932126
                                      </p>
                                      <p className="text-[16px] text-gray-300">
                                        Registration address: 72 Halliwick Road, London, England, N10 1AB
                                      </p>
                                      <p className="text-[16px] text-gray-300">
                                        Copyright © 2026. All Rights Reserved.
                                      </p>
                                    </div>
                                
                                    {/* Иконки оплаты */}
                                    <div className="mt-6 flex items-center gap-4">
                                      <img
                                        src={require('../assets/images/visa.png')}
                                        alt="Visa"
                                        className="w-12 h-auto"
                                      />
                                      <img
                                        src={require('../assets/images/mastercard.png')}
                                        alt="Mastercard"
                                        className="w-12 h-auto"
                                      />
                                    </div>
                                    <div className='flex items-center gap-2 text-[11px] md:text-xs'>
                                        <Lock className='h-4 w-4 text-white' />
                                        <span>Secure Payment</span>
                                    </div>
                                    <div className='flex items-center gap-2 text-[11px] md:text-xs'>
                                        <ShieldCheck className='h-4 w-4 text-white' />
                                        <span>PCI DSS Compliant</span>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <ToastContainer/>
        </footer>
    )
}
